const getCurrentLanguage = () => {
  try {
    const lang = localStorage.getItem('lang');
    return lang || 'ka'; // Default to 'ka' if no language is set
  } catch (error) {
    return 'ka'; // Default to 'ka' if localStorage is not available
  }
};

export default getCurrentLanguage;
